var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"file",class:{ 'hide': _vm.hide },attrs:{"type":"file","accept":_vm.acceptAttribute},on:{"change":function($event){return _vm.handleChange($event.target.files[0])}}})}
var staticRenderFns = []

export { render, staticRenderFns }